export const ALL_MESSAGES_REQUEST = "ALL_MESSAGES_REQUEST";
export const ALL_MESSAGES_SUCCESS = "ALL_MESSAGES_SUCCESS";
export const ALL_MESSAGES_FAIL = "ALL_MESSAGES_FAIL";
export const ALL_MESSAGES_ADD = "ALL_MESSAGES_ADD";
export const MESSAGES_SEEN_UPDATE = "MESSAGES_SEEN_UPDATE";
export const MESSAGE_SEEN_UPDATE = "MESSAGE_SEEN_UPDATE";

export const NEW_MESSAGE_REQUEST = "NEW_MESSAGE_REQUEST";
export const NEW_MESSAGE_SUCCESS = "NEW_MESSAGE_SUCCESS";
export const NEW_MESSAGE_RESET = "NEW_MESSAGE_RESET";
export const NEW_MESSAGE_FAIL = "NEW_MESSAGE_FAIL";

export const CLEAR_ERRORS = "CLEAR_ERRORS";